import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "app/components/button";
import { ConditionalButton } from "app/components/buttons";
import { CardBody } from "app/components/card-body";
import { CardFooter } from "app/components/card-footer";
import { CardHeader } from "app/components/card-header";
import { Checkbox } from "app/components/checkbox";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Input } from "app/components/input";
import { RouteError } from "app/components/route-error";
import { Row } from "app/components/row";
import { useEmpresa } from "app/contexts";
import toast from "react-hot-toast";

const initialState = {
  exportacion: {
    exportacion_detalles: "",
    exportacion_principal: false,
  },
  error: null,
};

export function ExportacionForm() {
  const params = useParams();
  const navigate = useNavigate();

  const { addExportacion, getExportacion, updateExportacion } = useEmpresa();

  const [state, setState] = useState(initialState);

  useEffect(() => {
    try {
      if (!!params.index) {
        const exportacion = getExportacion(parseInt(params.index));

        setState((state) => ({ ...state, exportacion }));
      }
    } catch (error) {
      setState((state) => ({ ...state, error }));
    }
  }, [params.index, getExportacion]);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!params.index) {
        const updated = updateExportacion(
          parseInt(params.index),
          state.exportacion
        );

        if (!!updated) {
          toast.success("¡Exportación actualizada!");

          return navigate("../../");
        }
      } else {
        const added = addExportacion(state.exportacion);

        if (!!added) {
          toast.success("¡Exportación agregada!");

          return navigate("../../");
        }
      }
    } catch (error) {
      return toast.error(error.message);
    }
  }

  if (!!state.error) {
    return <RouteError message={state.error.message} navigateTo="../../" />;
  }

  return (
    <div className="col-sm-12 col-xl-6 offset-xl-3">
      <form className="card" onSubmit={handleSubmit}>
        <CardHeader
          header={`${!!params.index ? "Editar" : "Agregar"} exportación`}
        />

        <CardBody>
          <Container>
            <Row>
              <Column>
                <Input
                  placeholder="Detalles de la exportación"
                  value={state.exportacion.exportacion_detalles}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      exportacion: {
                        ...state.exportacion,
                        exportacion_detalles: e.target.value,
                      },
                    }))
                  }
                  autoFocus
                />
              </Column>

              <Column>
                <Checkbox
                  label="¿Es una exportación principal?"
                  checked={state.exportacion.exportacion_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      exportacion: {
                        ...state.exportacion,
                        exportacion_principal: e.target.checked,
                      },
                    }))
                  }
                />
              </Column>
            </Row>
          </Container>
        </CardBody>

        <CardFooter>
          <DFlexResponsive justifyContent="end">
            <ConditionalButton
              type="submit"
              condition={!params.index}
              titleWhenTrue="Agregar"
              titleWhenFalse="Actualizar"
            />

            <Button
              color="secondary"
              outline
              title="Cancelar"
              onClick={() => navigate("../../")}
            />
          </DFlexResponsive>
        </CardFooter>
      </form>
    </div>
  );
}
